<div id="container" class="w-full">
  <div class="top">
    <input-wrap label="נחתם ע''י" cssClass=" w-half">
      <input
        type="text"
        [(ngModel)]="profile.signedBy"
        class="t-input t-input--colored"
      />
    </input-wrap>

    <a (click)="clear()">
      <img class="icon-action" src="assets\img\Delete.svg"
    /></a>
  </div>

  <div class="sign-container" id="signContainer">
    <app-signature-pad
      #signature
      [options]="signaturePadOptions"
      (drawStart)="drawStart($event)"
      (drawEnd)="drawComplete($event)"
    ></app-signature-pad>
  </div>
</div>
